export class AmisCardModel {
	amisCardNumber!: string;
}